<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 18.262 18.249"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width=".2"
      d="m17.255 12.584-1.6-1.6a2.557 2.557 0 0 0-3.585-.015 1.563 1.563 0 0 1-1.982.194 10.91 10.91 0 0 1-3.007-3 1.584 1.584 0 0 1 .206-1.989 2.557 2.557 0 0 0-.023-3.575l-1.6-1.6a2.552 2.552 0 0 0-3.6 0l-.46.46C-.786 3.86-.608 8.897 4.377 13.884c3.006 3.007 6.032 4.266 8.485 4.266a5.446 5.446 0 0 0 3.934-1.5l.46-.46a2.551 2.551 0 0 0-.001-3.606Zm-1.027 2.578-.46.46c-1.888 1.888-6.054 1.543-10.366-2.768S.746 4.372 2.634 2.484l.457-.46a1.1 1.1 0 0 1 1.549 0l1.6 1.6a1.1 1.1 0 0 1 .012 1.53 3.036 3.036 0 0 0-.386 3.8 12.351 12.351 0 0 0 3.422 3.417 3.034 3.034 0 0 0 3.8-.375 1.1 1.1 0 0 1 1.538.009l1.6 1.6a1.1 1.1 0 0 1 .007 1.555Z"
    />
  </svg>
</template>
